'use client';

import { useEffect, useRef, useState } from 'react';
import { Progress } from '@/shared/ui/shadcn/progress';

interface GlobalLoadingBarProps {
  isLoading?: boolean;
}

export function GlobalLoadingBar({ isLoading = false }: GlobalLoadingBarProps) {
  const [progress, setProgress] = useState(0);
  const [visible, setVisible] = useState(false);
  const intervalRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    if (isLoading) {
      setVisible(true);
      setProgress(10);

      // Gradually increase progress
      intervalRef.current = setInterval(() => {
        setProgress((prev) => {
          if (prev >= 90) return prev;
          // Slow down as we approach 90%
          const increment = prev < 50 ? 10 : prev < 70 ? 5 : 2;
          return prev + increment;
        });
      }, 300);
    } else {
      // Complete the progress
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
      setProgress(100);

      // Hide after animation completes
      setTimeout(() => {
        setVisible(false);
        setProgress(0);
      }, 300);
    }

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, [isLoading]);

  if (!visible) return null;

  return (
    <div className="fixed top-0 left-0 right-0 z-50">
      <Progress
        value={progress}
        className="h-1 rounded-none bg-background/20"
      />
    </div>
  );
}
